export const AI_CRITIQUE_PHASES = ['comprehension', 'technicalValidation', 'adequacy', 'gaps', 'decomposition', 'plan'] as const;

export type AiCritiquePhaseKey = (typeof AI_CRITIQUE_PHASES)[number];

export const FALLBACK_DEFAULT_AI_MODEL = 'anthropic/claude-3.5-sonnet';
